import React from "react";
import { useLocation, useParams } from "react-router-dom";

import ToBack from "../components/ToBack";

export default function TopicDetails() {
  const [item, setItem] = React.useState(0);
  const { search } = useLocation();
  const { id } = useParams();

  React.useEffect(() => {
    fetch(`/api/bulletin/${id}?option=banner`)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        }
        throw new Error("404");
      })
      .then((data) => {
        setItem(data);
        if (document.getElementById("editor-body") !== null) {
          document.getElementById("editor-body").innerHTML = data.comment;
        }
      })
      .catch((err) => console.error(err));
  }, [id, search]);

  return item === 0 ? (
    <div className="container-fluid">
      <ToBack />
    </div>
  ) : (
    <div className="container-fluid">
      <div className="card border-0 shadow mt-2">
        <ToBack category={item.title} />
        <div className="card-body">
          <div className="row mt-2" style={{ fontSize: 14 }}>
            <div className="col editor-body" id="editor-body" />
          </div>
        </div>
      </div>
    </div>
  );
}
